import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {HomepageMock} from './mock'

export const getHomepageData = createAsyncThunk(
  'getHomepageData',
  async (p: any, store: any) => {
    // return HomepageMock
    const resp = await http.post(
      '/live/activity/get_2025_anniversary_recharge_homepage',
      {
        ...p,
      },
      {
        store: window.store,
      }
    )
    return resp.data?.data
  }
)

const initialState: {
  isShowRule?: boolean
  homepage?: {
    err_msg?: string
    start_time?: string
    end_time?: string
    act_status?: number
    new_stage_id?: number
    first_recharge_reward?: {
      status?: number
      records?: {
        reward_id?: number
        reward_type?: string
        reward_time?: string
        icon?: string
        name?: string
        num?: number
        ticket_num?: number
        reward_coins?: number
        has_show_effect?: boolean
      }[]
    }
    user_ticket_reward?: {
      used_ticket_num?: number
      coins?: number
      ticket_records?: {
        reward_id?: number
        reward_type?: string
        reward_time?: string
        reward_tag?: string
        icon?: string
        name?: string
        num?: number
        ticket_num?: number
        has_show_effect?: boolean
      }[]
    }
    now_ticket_reward?: {
      reward_id?: number
      reward_type?: string
      reward_time?: string
      reward_tag?: string
      icon?: string
      name?: string
      num?: number
      ticket_num?: number
      has_show_effect?: boolean
    }[]
    need_pop_stage?: number
    recharge_num?: number
    stage_task_list?: {
      id?: number
      status?: number
      num?: number
      reward_tag?: string
      reward_infos?: {
        reward_id?: number
        reward_type?: string
        reward_time?: string
        reward_tag?: string
        icon?: string
        name?: string
        num?: number
        has_show_effect?: boolean
      }[]
    }[]
    bonus_max_coins?: number
    recharge_to_pool_rate?: number
    area_info?: {
      area_stage?: number
      area_pool?: number
      area_reward?: {
        coins_rank?: number[]
        ticket_rank?: number[]
        pri_rank?: number[]
      }
      area_bonus_task_list?: {
        id?: number
        status?: number
        num?: number
      }[]
    }
    bonus_task_info?: {
      stages?: {
        stage_no?: number
        stage_need?: number
        status?: number
      }[]
      stage_score?: number
      stage_no?: number
    }
    personal_task_info?: {
      stages?: {
        stage_no?: number
        stage_need?: number
        status?: number
      }[]
      stage_score?: number
    }
  }
} = {
  isShowRule: false,
  homepage: {},
}

export const AnnualRecharge2025Slice = createSlice({
  name: 'AnnualRecharge2025',
  initialState,
  reducers: {
    setIsShowRule: (state, action) => {
      Object.assign(state, {
        isShowRule: action.payload,
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getHomepageData.fulfilled, (state, action) => {
      const {
        area_info = {},
        recharge_num,
        stage_task_list = [],
      } = action.payload || {}
      const {area_stage, area_pool, area_bonus_task_list} = area_info
      const bonus_stages = []
      area_bonus_task_list?.forEach((item) => {
        bonus_stages.push({
          stage_no: item?.id,
          stage_need: item?.num,
          status: item?.status,
        })
      })
      const bonus_task_info = {
        stages: bonus_stages,
        stage_score: area_pool,
        stage_no: area_stage,
      }
      const personal_stages = []
      stage_task_list?.forEach((item) => {
        personal_stages.push({
          stage_no: item?.id,
          stage_need: item?.num,
          status: item?.status,
        })
      })
      const personal_task_info = {
        stages: personal_stages,
        stage_score: recharge_num,
      }
      Object.assign(state?.homepage, {
        ...action.payload,
        bonus_task_info,
        personal_task_info,
      })
    })
  },
})

export default AnnualRecharge2025Slice.reducer
export const AnnualRecharge2025Actions = AnnualRecharge2025Slice.actions
